import { Injectable } from '@angular/core'
import { Actions, ofType, createEffect } from '@ngrx/effects'
import { switchMap, map, catchError, tap, filter, take, mapTo } from 'rxjs/operators'
import { of } from 'rxjs'

import { FlightNetworksService, FlightNetwork } from 'src/app/flight-network/shared'
import * as NetworkActions from '../actions/flight-network.actions'
import * as UserActions from '../actions/user.actions'
import * as CenterActions from '../actions/center.actions'
import { ToastrService } from 'ngx-toastr'
import { Store } from '@ngrx/store'
import { AppState, getFlightNetwork } from '..'
import { ErrorHandlerService } from 'src/app/common/error-handler.service'

@Injectable()
export class FlightNetworkEffects {
  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.authenticateSuccess, NetworkActions.loadFlightNetwork),
      switchMap(() =>
        this.flightsNetworkService.refreshNetwork$().pipe(
          map((network) =>
            NetworkActions.loadFlightNetworkSuccess({
              network: network.toJSON(),
            }),
          ),
          catchError((error) => of(NetworkActions.loadFlightNetworkFailure({ error }))),
        ),
      ),
    ),
  )

  edit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NetworkActions.editFlightNetwork),
      switchMap((action) => {
        return this.flightsNetworkService.refreshNetwork$().pipe(
          switchMap((actual) => {
            const newData = {
              ...action.network,
              centers: actual.centers,
            }
            const newNetwork = new FlightNetwork(newData)
            return this.flightsNetworkService.edit(newNetwork)
          }),
          tap(() => {
            const message = `Network ${action.network.name || action.network.id} successfully edited`
            console.log(message)
            this.toastr.success(message)
          }),
          map(() => NetworkActions.loadFlightNetwork()),
          catchError((error) => {
            const message = `Error while editing network ${action.network.name || action.network.id}`
            this.errorHandlerService.showErrorMessage(error, message)
            return of(NetworkActions.editFlightNetworkFailure({ error }))
          }),
        )
      }),
    ),
  )

  updateCenter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CenterActions.changeOpenState),
      switchMap((action) =>
        this.store.select(getFlightNetwork).pipe(
          take(1),
          filter((network) => Boolean(network)),
          mapTo(action),
        ),
      ),
      map(({ center_id, open_state }) => NetworkActions.updateFlightNetworkCenterOpenState({ center_id, open_state })),
    ),
  )

  constructor(
    private actions$: Actions,
    private flightsNetworkService: FlightNetworksService,
    private toastr: ToastrService,
    private store: Store<AppState>,
    private errorHandlerService: ErrorHandlerService,
  ) {}
}
